/**
 * Thrown when the backend rejects a creation request (403)
 * because the tenant has reached a plan limit.
 */
export class PlanLimitError extends Error {
  override name = "PlanLimitError";

  constructor(public readonly backendMessage: string) {
    super("PLAN_LIMIT");
  }
}

export function isPlanLimitError(err: unknown): err is PlanLimitError {
  return err instanceof Error && err.name === "PlanLimitError";
}
